import {  get_days, get_weeks, get_months, get_years } from './dates'


export function checkString(data){
  if (typeof data != "undefined") {
    if (data.trim() != ""){
      return true;

    }
  }

  return false;
}

export function checkNumber(data){
  if (typeof data != "undefined") {
    if (data.length && !isNaN(data)){
      if (data > 0){
        return true;
      }

    }
  }

  return false;
}

export function checkFloat(data){
  if (typeof data != "undefined") {
    if (data.length && !isNaN(parseFloat(data))){
      if (data > 0){
        return true;
      }

    }
  }

  return false;
}


export function checkArray(data){

  if (typeof data != "undefined") {
    if (data.length > 0){
      return true;

    }
  }

  return false;
}

export function removeCommonValues(arr1, arr2) {
  const set1 = new Set(arr1);

  for (let i = 0; i < arr2.length; i++) {
    if (set1.has(arr2[i])) {
      arr1.splice(arr1.indexOf(arr2[i]), 1);

      arr2.splice(i, 1);

      i--;
    }
  }
}

export function removeValueFromArray(value, array) {
  const index = array.indexOf(value);
  if (index !== -1) {
    array.splice(index, 1);
  }
  return array;
}


export function createTopFilters(topFilter, language){
  if (typeof topFilter != "undefined"){

    let top_filter = {
      position: 'top',
      type: topFilter.type,
      name: topFilter.populate,
      title: topFilter.populate ,
      value: "all",
      // today: topFilter.today,
      or: false,
    }
    if (topFilter.type == "date"){
      if (topFilter.populate == "auto"){

        let options = get_days(topFilter.today);
        top_filter.options = [...topFilter.values, ...options];
        top_filter.title = "Explore the next 2 weeks";
      }

      if (topFilter.populate == "daily"){

        let options = get_days(topFilter.today);
        top_filter.options = [...topFilter.values, ...options];
        top_filter.title = "Explore the next 2 weeks";

      }

      if (topFilter.populate == "weekly"){

        let options = get_weeks(topFilter.today);
        top_filter.options = [...topFilter.values, ...options];
        top_filter.title = "Explore the next few weeks";

      }

      if (topFilter.populate == "monthly"){

        let options = get_months(topFilter.today);
        top_filter.options = [...topFilter.values, ...options];
        top_filter.title = "Explore the next few months";

      }

      if (topFilter.populate == "yearly"){

        let options = get_years(topFilter.today);
        top_filter.options = [...topFilter.values, ...options];
        top_filter.title = "Explore the next few years";

      }


      top_filter.value = new Date().setHours(0,0,0,0) / 1000;

    } else {
      top_filter.options = [...topFilter.values];
      top_filter.value = "all";
    }

    if (language.top_nav_title.length){
      top_filter.title = language.top_nav_title;

    }



    return top_filter;
  } else {
    return "";
  }
}
